<template>
  <div class="main">
    <div class="person-text">
      <div>
        <!-- 亲爱的{{userInfo.real_name}},欢迎您的到来！！！ -->
        <!-- {{userInfo.school?userInfo.school.slogan:''}} -->
        <!-- <br/> -->
        <p v-html="userInfo.student_greetings"></p>
      </div>
      <div>
        <img v-if="userInfo.school && userInfo.school.logo" :src="path + userInfo.school.logo" alt="">
        <!-- <div style="font-size: 15px"> -->
        <!-- <p style="color:#333">{{userInfo.real_name}}</p>
        <p><span>赠送积分:</span>{{jifenobj.given_integral}}</p>
        <p><span>充值积分:</span>{{jifenobj.recharge_integral}}</p> -->
        <!-- </div> -->
      </div>
    </div>
    <Menu theme="light" :active-name="activename" style="width:100%">
      <Menu-item @click.native="pat(i, n)" :name="i.url" v-for="(i, n) in menuList" :key="n">
        <Icon :type="i.icon"></Icon>
        {{ i.name }}
      </Menu-item>
    </Menu>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  export default {
    computed: {
      ...mapState({
        menuList(state) {
          return state.global.leftMenu;
        },
        userInfo(state) {
          return state.user.userInfo;
        }
      }),
    },
    watch: {
    },
    mounted() {
      // this.activename=this.menuList[0].url
      console.log(this.activename)
      // this.getjifen()
    },
    destroyed() {
      // window.clearTimeout(this.timer)
    },
    methods: {
      pat(item) {
        this.activename = item.url
        this.$router.push(item.url)
      },
      getjifen() {
        console.log(this.userInfo)
        this.$axios
          .get("/app/user/getIntegral")
          .then((res) => {
            if (res.code == 1) {
              this.jifenobj = res.data;
            }
          })
        // this.timer =setTimeout(this.getjifen, 600000);
      }
    },
    data() {
      return {
        jifenobj: {},
        activename: '',
        timer: null
      };
    },
  };
</script>
<style lang="less" scoped>
  .main {
    width: 14vw;
    margin-right: 20px;
    /deep/.ivu-menu-light {
      background: transparent;
    }
    /deep/.ivu-menu-item {
      margin-top: 5px;
      background: #fff;
    }
    .person-text {
      width: 100%;
      min-height: 15vh;
      text-align: center;
      font-size: 12px;
      margin-bottom: 10px;
      padding: 30px 0 4px;
      background: #fff;
      div {
        width: 90%;
        text-align: right;
      }
      div:nth-child(1) {
        width: 90%;
        margin: 0 auto;
        text-align: center;
      }
      div:nth-child(2) {
        display: flex;
        margin: 4px 0 4px 8px;
        align-items: center;
        img {
          width: 100%;
          // height:4vw;
          padding: .2vw;
          // border-radius: 50%;
        }
        div {
          display: block;
          text-align: left;
          color: #999;
          span {
            font-size: 12px;
          }
        }
      }
      div:nth-child(3) {
        background: rgb(117, 117, 117);
        width: 90%;
        height: 20px;
        line-height: 20px;
        margin: 5px 0 0 20px;
        color: #fff;
        text-align: center;
        border-radius: 3px;
        font-size: 12px;
      }
    }
  }
</style>
